const collection = {
    slug: "junya-watanabe-2022aw-spiraling-winter-ghosts-guide",
    metaTitle:
      "JUNYA WATANABE 2022AWとは｜ライダース・フライトジャケット・チェックジャケットのシルエット解体とジュンヤワタナベ買取レンタルガイド",
    metaDescription:
      "JUNYA WATANABE 2022-2023AW『The Spiraling of Winter Ghosts』を解説。ライダース、フライトジャケット、ウールチェックジャケットの3要素を使い、渡辺淳弥が作りたかったシルエットとは何だったのか。レザー、ボンバー、チェック、三角形、バージャケット、コクーン、パッチワークからEnclopedia独自の視点で読み解き、JUNYA WATANABE買取・レンタル導線へ案内します。",
    metaKeywords:
      "JUNYA WATANABE 2022AW,JUNYA WATANABE 2022-2023AW,ジュンヤワタナベ 2022AW,ジュンヤワタナベ 2022-2023AW,ジュンヤワタナベ 2022秋冬,JUNYA WATANABE The Spiraling of Winter Ghosts,JUNYA WATANABE Plight,ジュンヤワタナベ ライダース,ジュンヤワタナベ フライトジャケット,ジュンヤワタナベ ウールチェックジャケット,ジュンヤワタナベ パッチワーク,JUNYA WATANABE ライダース,JUNYA WATANABE フライトジャケット,JUNYA WATANABE チェックジャケット,JUNYA WATANABE 買取,ジュンヤワタナベ 買取,JUNYA WATANABE レンタル,ジュンヤワタナベ レンタル,COMME des GARCONS 買取,コムデギャルソン 買取,Enclopedia,アンクロペディア,アーカイブファッション",
    canonicalPath:
      "/archive_collection/junya-watanabe-2022aw-spiraling-winter-ghosts-guide",
    heroImage:
      "media/archive_fashion/archive30.png",
    heroImageAlt:
      "JUNYA WATANABE 2022-2023AW The Spiraling of Winter Ghostsを解説するEnclopediaアーカイブガイド画像",
    heroNumber: "30 / THE SPIRALING OF WINTER GHOSTS",
    label: "ARCHIVE COLLECTION STUDY",
    title:
      "JUNYA WATANABE 2022-2023AW『The Spiraling of Winter Ghosts』",
    lead:
      "JUNYA WATANABE 2022-2023AW。\n\nこのシーズンを、単に“ライダースを解体したコレクション”として見ると浅くなります。\n\n渡辺淳弥がここで扱ったのは、主に3つの服です。\n\nライダースジャケット。\nフライトジャケット。\nウールチェックジャケット。\n\nどれも、すでに強い意味を持つ服です。\n\nライダースは反抗、スピード、硬さ、身体の防御。\nフライトジャケットは軍用、空、機能、丸み、保温性。\nウールチェックジャケットは英国性、古着、日常、クラシック、温度。\n\nしかし2022-2023AWで重要なのは、それらの服をそのまま見せたことではありません。\n\n渡辺が作りたかったのは、ライダースでも、フライトジャケットでも、チェックジャケットでもない。\n\nその3つの服を素材として使いながら、まったく別のシルエットを作ることでした。\n\n黒いレザーが巨大な三角形になる。\nライダースのベルトやジップが、身体を締めるためではなく、構造線として浮かび上がる。\nボンバーの丸みが、腰や袖のボリュームへ転送される。\nウールチェックの温かさが、パッチワークされたドレスやコートの表面へ変わる。\n\nつまりこれは、既存の服を組み合わせたリメイクではありません。\n服の記憶を解体し、別の身体の輪郭へ変換するコレクションです。\n\nEnclopediaでは、JUNYA WATANABE 2022-2023AWを、“古い服を新しくしたコレクション”ではなく、ライダース、フライトジャケット、ウールチェックジャケットという3つの既製服から、渡辺が作りたいシルエットを抽出したコレクションとして読み解きます。",
    keywordLine: [
      "junya watanabe 2022aw",
      "motorcycle jacket",
      "flight jacket",
      "wool check jacket",
    ],
    thesis:
      "JUNYA WATANABE 2022-2023AWの本質は、ライダース、フライトジャケット、ウールチェックジャケットをリメイクすることではなく、それぞれが持つ硬さ、丸み、温度、記憶を分解し、三角形、コクーン、ペプラム、ケープ、ドレスのような別の身体シルエットへ変換した点にあります。",
    whyTitle:
      "渡辺淳弥が作りたかったシルエットとは何だったのか。",
    whyBody:
      "このシーズンで渡辺淳弥が作りたかったシルエットは、単一の服の形ではありません。\n\nライダースのシルエットでもない。\nフライトジャケットのシルエットでもない。\nチェックジャケットのシルエットでもない。\n\nむしろ、それらを壊した後に現れる“架空のクチュールシルエット”です。\n\nライダースの硬いレザーは、本来なら身体に沿って防御するための素材です。\nしかし2022-2023AWでは、そのレザーが巨大なケープや三角形の構造を作ります。\n\nフライトジャケットは、本来なら機能服です。\n空軍、保温、防風、丸みのあるボンバー型。\nしかしこのシーズンでは、その丸みが袖、腰、背中、ドレスのような量感へ移されます。\n\nウールチェックジャケットは、日常的でクラシックな服です。\nしかし渡辺は、それをただの古着的素材として使うのではなく、レザーやナイロンの強さとぶつけることで、温度と記憶を持った表面へ変えています。\n\n結果として生まれるのは、普通のリメイクではありません。\n\nライダースの反抗性。\nフライトジャケットの機能性。\nチェックジャケットの古着性。\n\nそれらが身体の上で合成され、Diorのバージャケット、Balenciagaのコクーン、ヴィクトリアンなドレープ、パンクの再構成が同時に立ち上がる。\n\nEnclopediaでは、このシーズンを“服から服を作った”のではなく、“服からシルエットを抽出した”コレクションとして見ます。",
    pillars: [
      {
        number: "01",
        title: "GARMENT AS MATERIAL",
        text:
          "ライダース、フライトジャケット、ウールチェックジャケットは完成品として扱われていません。それらは新しいシルエットを作るための素材、パーツ、記憶として分解されています。",
      },
      {
        number: "02",
        title: "SILHOUETTE BEFORE ITEM",
        text:
          "渡辺が作りたかったのは、ライダースでもボンバーでもチェックジャケットでもなく、それらを通過した先にある三角形、コクーン、ペプラム、ケープ、ドレスのようなシルエットです。",
      },
      {
        number: "03",
        title: "COUTURE FROM STREETWEAR",
        text:
          "ライダースやボンバーというストリートやユーティリティの服から、フレンチクチュールのような構築的なシルエットが生まれています。ここにJUNYA WATANABEらしい高度な矛盾があります。",
      },
      {
        number: "04",
        title: "ARCHIVE VALUE",
        text:
          "2022-2023AWは、JUNYA WATANABEの解体・再構築の中でも、素材ではなくシルエットが主役になった重要シーズンです。買取やレンタルでは、単なるパッチワークではなく、どの服の記憶がどの造形へ変換されているかを見る必要があります。",
      },
    ],
    readingTitle:
      "ライダース、フライトジャケット、ウールチェックジャケットから読むJUNYA WATANABE 2022-2023AW。",
    readingIntro:
      "このコレクションは、古いジャケットの再利用ではありません。渡辺淳弥は、ライダース、フライトジャケット、ウールチェックジャケットという3つの服から、硬さ、丸み、温度、反抗性、機能性、古着性を取り出し、それらを三角形、ケープ、コクーン、ペプラム、ドレスのような新しいシルエットへ変換しました。重要なのは、服の意味よりも、服が身体の周囲に作る輪郭です。",
    observations: [
      {
        index: "01",
        title:
          "2022-2023AWは、リメイクではなく“シルエット抽出”のコレクションである",
        text:
          "JUNYA WATANABE 2022-2023AWを見ると、まず目に入るのはパッチワークです。\n\nライダースのレザー。\nボンバーのナイロン。\nウールチェック。\nジップ。\nベルト。\nリブ。\nファー。\n\nしかし、このシーズンをパッチワークやリメイクとして見るだけでは不十分です。\n\n渡辺がしているのは、古い服を組み合わせて新しい服を作ることではありません。\n\n既存の服から、シルエットの可能性だけを抜き出している。\n\nライダースからは硬さと斜線。\nフライトジャケットからは丸みと膨らみ。\nチェックジャケットからは温度とクラシックな表面。\n\nそれらを分解し、身体の周囲に再配置することで、元の服とは違う輪郭が生まれています。\n\nつまりこのシーズンの主役は、素材ではなくシルエットです。",
      },
      {
        index: "02",
        title:
          "ライダースは、反抗の記号から建築的な外殻へ変わる",
        text:
          "ライダースジャケットは、非常に強い服です。\n\nバイク。\n反抗。\nパンク。\nロック。\nレザー。\nジップ。\nベルト。\n身体を守る硬さ。\n\n普通なら、ライダースは身体に近い服です。\n肩、胸、腕を包み、着る人の身体を鋭く見せる。\n\nしかし2022-2023AWでは、ライダースは身体に沿う服ではなくなります。\n\nレザーのパネルが拡張され、三角形やケープのように身体から離れる。\nジップやベルトは機能ではなく、構造線になる。\n\nライダースは反抗の記号である前に、建築的な外殻になります。\n\n渡辺はライダースを着せているのではなく、ライダースのパーツで別の身体を建てているのです。",
      },
      {
        index: "03",
        title:
          "フライトジャケットは、軍用機能から丸みのある量感へ変換される",
        text:
          "フライトジャケットやボンバーは、もともと機能服です。\n\n空軍。\n保温。\n防風。\n短い着丈。\nリブ。\n丸み。\n実用性。\n\nしかしこのシーズンでは、その機能性が本来の意味から切り離されています。\n\nボンバーの丸みは、防寒のためではなく、シルエットを作るために使われる。\n袖や腰に生まれる膨らみは、身体を守る機能ではなく、身体の形を変える造形になる。\n\nフライトジャケットは、空を飛ぶための服ではなく、身体の周囲に空気を含ませるための服になる。\n\nこの変換が、渡辺淳弥らしい。\n\n機能服を機能から切り離し、造形のための部品に変えるのです。",
      },
      {
        index: "04",
        title:
          "ウールチェックジャケットは、温度と古着の記憶を持ち込む",
        text:
          "ライダースとフライトジャケットだけで構成されていたら、このコレクションはもっと硬く、冷たく、攻撃的に見えたはずです。\n\nそこにウールチェックジャケットが入ることで、空気が変わります。\n\nチェックには温度があります。\n古着の記憶があります。\n英国的なクラシックさがあります。\n日常のジャケットとしての親しみがあります。\n\nこの温度が、レザーやナイロンの硬さと衝突する。\n\nウールチェックは、単なる柄ではありません。\n冷たい構造に、人間的な古さと柔らかさを入れる素材です。\n\n2022-2023AWのシルエットが異様なのにどこか服として惹かれるのは、このチェックの温度があるからです。",
      },
      {
        index: "05",
        title:
          "三角形のシルエットは、身体を隠すのではなく別の重心を作る",
        text:
          "このシーズンで印象的なのが、三角形に近いシルエットです。\n\n巨大なケープ。\nピラミッドのようなレザーの集合。\n裾へ向かって広がる量感。\n\nこれは、身体を単に隠すための大きさではありません。\n\n重心を変えるためのシルエットです。\n\n通常、ジャケットは肩から身体を構成します。\nライダースもボンバーも、肩、胸、腕を中心に設計されています。\n\nしかし三角形のシルエットでは、重心が下へ落ちる。\n肩ではなく、裾や腰に力が移る。\n\n身体の強さが上半身の筋肉ではなく、布の構造によって作られる。\n\nこの重心の移動こそ、渡辺が作りたかったシルエットの核心です。",
      },
      {
        index: "06",
        title:
          "Diorのバージャケット的な腰の作り方が、ライダースの硬さと衝突する",
        text:
          "Vogueが指摘したように、このシーズンにはDiorのバージャケットを思わせるラインがあります。\n\n絞られたウエスト。\n膨らむヒップ。\nペプラム的な構造。\n\n本来、バージャケットはフレンチクチュールの女性的な身体を作る服です。\n\n一方で、ライダースはストリート、反抗、硬いレザー、男性的な記号を強く持つ服です。\n\nこの二つが衝突することが面白い。\n\nライダースの素材で、クチュール的な腰を作る。\n反抗の服で、優雅なペプラムを作る。\n硬いレザーで、女性的な曲線を作る。\n\nここに、JUNYA WATANABEの高度な逆説があります。\n\n彼はライダースを女性化しているのではありません。\nライダースの硬さを使って、クチュールのシルエットを再構築しているのです。",
      },
      {
        index: "07",
        title:
          "Balenciaga的なコクーンは、ボンバーの丸みから生まれる",
        text:
          "このシーズンには、Balenciaga的なコクーンの感覚もあります。\n\n身体を包み込む丸み。\n外側へ膨らむ量感。\n服が身体から離れて作る空間。\n\nこのコクーン的な形は、フライトジャケットやボンバーの丸みと相性がいい。\n\nボンバーの丸みは、本来は保温や機能のためです。\nしかし渡辺は、その丸みをクチュールの量感へ移します。\n\nつまり、ボンバーの機能的な膨らみが、Balenciaga的な造形へ変わる。\n\nこれは単なる引用ではありません。\n\nストリートやミリタリーの服が、フレンチクチュールの空間性を作る。\n\nこの変換こそ、2022-2023AWの面白さです。",
      },
      {
        index: "08",
        title:
          "ジップやベルトは、留めるためではなく“線”として使われる",
        text:
          "ライダースのジップやベルトは、通常は機能です。\n\n閉める。\n締める。\n固定する。\n身体を守る。\n\nしかしこのシーズンでは、それらのディテールが機能から離れています。\n\nジップは身体を開閉するためだけではなく、パネルの境界線になる。\nベルトは腰を締めるためだけではなく、服の表面を走る線になる。\n\nつまり、機能ディテールがグラフィック化されている。\n\nただし、それは平面的な装飾ではありません。\n\nジップやベルトがあることで、服の成り立ちが見える。\nどこが元のライダースだったのか。\nどこで切られたのか。\nどこで再構成されたのか。\n\n構造の痕跡としての線です。",
      },
      {
        index: "09",
        title:
          "David SylvianとHolger Czukayの『Plight』は、服の作り方そのものに関係している",
        text:
          "このコレクションは、David SylvianとHolger Czukayの『Plight（The Spiraling of Winter Ghosts）』に着想を得ています。\n\n重要なのは、音楽を視覚的に引用したことではありません。\n\nVogueも指摘しているように、渡辺はDavid Sylvianの見た目やNew Romantic的な記号をそのまま使ったわけではありません。\n\nむしろ、即興的な制作プロセスに反応している。\n\n音が重なり、ずれ、偶然のように構成される。\n\nこの服も同じです。\n\nライダース、ボンバー、チェックジャケットが重なり、ずれ、別の輪郭へ変わる。\n\n音のレイヤーが服のレイヤーに変換されている。\n\nEnclopediaでは、このシーズンを“音楽をテーマにした服”ではなく、“音楽の作られ方を服の構造へ置き換えたコレクション”として読みます。",
      },
      {
        index: "10",
        title:
          "ゴーストとは、古い服の記憶のことである",
        text:
          "The Spiraling of Winter Ghosts。\n\nこのタイトルにある“Ghosts”を、Enclopediaでは古い服の記憶として読みます。\n\nライダースだった記憶。\nフライトジャケットだった記憶。\nチェックジャケットだった記憶。\n\nそれらは完全には消えていません。\n\nジップを見ればライダースを思い出す。\nリブを見ればボンバーを思い出す。\nチェックを見れば古いウールジャケットを思い出す。\n\nしかし、もう元の服ではない。\n\n記憶だけが残り、形は別のものになっている。\n\nつまりこのコレクションの“冬の亡霊”とは、過去の衣服そのものです。\n\n渡辺は古い服を蘇らせたのではなく、古い服の亡霊を新しいシルエットの中に住まわせています。",
      },
      {
        index: "11",
        title:
          "このシーズンは、ストリートウェアをクチュールへ持ち上げている",
        text:
          "ライダース、ボンバー、チェックジャケットは、どれも日常やストリートに近い服です。\n\nしかし2022-2023AWでは、それらがドレス、ケープ、コート、ペプラム、コクーンのような形へ変換されています。\n\nここで起きているのは、ストリートウェアのクチュール化です。\n\nただし、きれいに装飾して高級に見せているわけではありません。\n\n古い服の傷、硬さ、パーツ、歪みを残したまま、クチュール的なシルエットへ引き上げている。\n\nだから美しいだけでは終わらない。\nどこか荒く、どこか怖く、どこか未完成に見える。\n\nその荒さこそが、JUNYA WATANABEのクチュール性です。",
      },
      {
        index: "12",
        title:
          "買取で見るべきなのは、単なるパッチワークかどうかではない",
        text:
          "JUNYA WATANABE 2022-2023AWの買取では、単にパッチワークだから価値がある、という見方では不十分です。\n\n重要なのは、そのパッチワークが何を作っているかです。\n\nライダースのパーツが残っているか。\nボンバーの丸みやリブが構造に使われているか。\nウールチェックが温度や表面の変化を作っているか。\nジップやベルトが構造線として機能しているか。\nシルエットが三角形、コクーン、ペプラム、ケープ、ドレスのように強く変換されているか。\n\nこのシーズンは、素材の珍しさ以上に、シルエットの強さが重要です。\n\nEnclopediaでは、JUNYA WATANABEを単なるブランド古着としてではなく、シーズン背景、造形、素材、状態、現在の需要まで含めて確認します。",
      },
      {
        index: "13",
        title:
          "レンタルで分かるのは、ジャケットがドレスへ変わる重さである",
        text:
          "2022-2023AWのような服は、画像だけでは理解しきれません。\n\nレザーの重さ。\nボンバーの丸み。\nチェックウールの厚み。\nジップやベルトの硬さ。\n身体から離れる三角形の量感。\n歩いたときの裾の揺れ。\n\n実際に着ることで、ジャケットだったものが、身体の上でドレスやケープのように振る舞う感覚が分かります。\n\nこれは、JUNYA WATANABEの服を理解するうえで非常に重要です。\n\n服のジャンルはライダースでも、身体感覚はライダースではない。\n元はフライトジャケットでも、着るとクチュールのように感じる。\n\nEnclopediaのレンタル体験は、そのズレを身体で確認するための方法になります。",
      },
    ],
    quote:
      "JUNYA WATANABE 2022-2023AWとは、ライダースを作ったコレクションではない。ライダース、フライトジャケット、チェックジャケットの記憶から、渡辺淳弥が作りたいシルエットを抽出したコレクションです。",
    perspectiveTitle:
      "Enclopediaは、JUNYA WATANABE 2022-2023AWを“リメイク服”ではなく“既製服の記憶からシルエットを作るアーカイブ”として扱う。",
    perspectiveCards: [
      {
        number: "01",
        title: "KNOWLEDGE",
        text:
          "ライダース、フライトジャケット、ウールチェックジャケットの3要素を、素材ではなくシルエット生成装置として読み解きます。",
      },
      {
        number: "02",
        title: "EXPERIENCE",
        text:
          "このシーズンの服は、実際に着ることで理解が深まります。レザーの重さ、ボンバーの丸み、チェックの温度、三角形の量感をレンタルで体験できます。",
      },
      {
        number: "03",
        title: "ARCHIVE VALUE",
        text:
          "2022-2023AWは、JUNYA WATANABEの解体・再構築の中でも、服の記憶を別のシルエットへ変換した重要シーズンです。Enclopediaでは時期と文脈まで含めて確認します。",
      },
    ],
    experienceTitle:
      "JUNYA WATANABE 2022-2023AWを売る前に、その一着がどの“シルエット変換”を持つかを確認する。",
    experienceBody:
      "JUNYA WATANABE 2022-2023AWの買取では、ブランド名だけでなく、シーズン、素材、ディテール、シルエット、状態、現在の需要が重要です。\n\n特にこのシーズンは、ライダース、フライトジャケット、ウールチェックジャケットという3つの要素がどのように再構成されているかが価値の核心になります。\n\n単なるレザーアイテムなのか。\n単なるボンバーなのか。\n単なるチェックジャケットなのか。\n\nそれとも、ライダースのジップやベルト、ボンバーの丸み、ウールチェックの表面が組み合わさり、三角形、ケープ、ペプラム、コクーン、ドレスのようなシルエットへ変換されているのか。\n\nここで評価は大きく変わります。\n\nEnclopediaでは、JUNYA WATANABEを単なるブランド古着としてではなく、渡辺淳弥がどのような既製服を分解し、どのような新しい身体の輪郭を作ったのかという視点で確認します。",
    experienceItems: [
      "JUNYA WATANABEのタグ・AD表記・シーズンを確認する",
      "2022-2023AW『The Spiraling of Winter Ghosts』に該当するか確認する",
      "ライダース、フライトジャケット、ウールチェックジャケットの要素があるか確認する",
      "ジップ、ベルト、リブ、ファー、チェック、レザーパネル、ナイロン切替などのディテールを撮影する",
      "三角形、ケープ、ペプラム、コクーン、ドレス的なシルエットがあるか確認する",
      "レザーの擦れ、硬化、ひび割れ、ジップ不良、ベルト欠損、ウールの毛羽立ち、虫食いを確認する",
      "ショールックに近いアイテムか、販売時の付属品・タグ・レシートがあるか確認する",
      "シーズン不明の場合もLINEで写真を送る",
    ],
    archiveItemsTitle:
      "2022-2023AWを入口に、JUNYA WATANABEの買取・レンタルへ。",
    archiveItemsBody:
      "Enclopediaでは、JUNYA WATANABEを単なるブランド古着としてではなく、渡辺淳弥の解体・再構築、既製服の記憶、素材、シルエット、現在の需要まで含めて見ています。2022-2023AWのようなアーカイブ性の強いアイテムをお持ちの方は、まずはLINEでご相談ください。",
    archiveItems: [
      {
        label: "BUYBACK FOCUS 01",
        title: "JUNYA WATANABEの価値を相談する",
        productPath:
          "https://line.me/R/ti/p/@240yzqkh",
        productImage: "",
        text:
          "JUNYA WATANABEのライダース、変形ジャケット、パッチワーク、チェック、レザー、フライトジャケット再構築アイテムまで。シーズン文脈込みで確認します。",
      },
      {
        label: "BUYBACK FOCUS 02",
        title: "COMME des GARCONS買取ページへ",
        productPath:
          "/brand_buyback/comme-des-garcons",
        productImage: "",
        text:
          "COMME des GARCONS、JUNYA WATANABE、JUNYA WATANABE MAN、HOMME PLUSなど、コムデギャルソン関連ブランド全体の買取相談へ進めます。",
      },
      {
        label: "RENTAL FOCUS 03",
        title: "レンタルできるJUNYA WATANABEを見る",
        productPath:
          "JUNYA%20WATANABE（ジュンヤワタナベ）/?number=32",
        productImage: "",
        text:
          "JUNYA WATANABEの構造的な服やコラボレーションは、実際に着ることで理解が深まります。Enclopediaでジュンヤワタナベのアーカイブを体験できます。",
      },
      {
        label: "BUYBACK FOCUS 04",
        title: "JUNYA WATANABE買取ページへ",
        productPath:
          "/brand_buyback/junya-watanabe",
        productImage: "",
        text:
          "JUNYA WATANABE MAN 2023AW Innerraumを含むジャケット、コート、パンツ、バッグ、コラボアイテムまで。ジュンヤワタナベの買取対象と査定視点を確認できます。",
      },
    ],
    finalCta: {
      title:
        "JUNYA WATANABE 2022-2023AWを読んだら、次はその一着の“シルエット変換”を相談する。",
      body:
        "JUNYA WATANABE 2022-2023AWは、ライダース、フライトジャケット、ウールチェックジャケットを単に再利用したコレクションではありません。\nそれぞれの服が持つ硬さ、丸み、温度、記憶を分解し、三角形、ケープ、ペプラム、コクーン、ドレスのような別のシルエットへ変換した重要シーズンです。\n\nEnclopediaでは、JUNYA WATANABEの買取相談を入口に、シーズン背景、造形、素材、レンタル体験までつなげます。\nまずはLINEでタグ・品質表示・全体写真・ディテール写真をお送りください。",
      buttonLabel: "JUNYA WATANABEをLINEで事前査定する",
      buttonHref: "https://line.me/R/ti/p/@240yzqkh",
    },
  };
  
  export default collection;